export enum BranchStatus {
  green = 'green', // 'success'
  yellow = 'yellow', // 'created', 'running'
  red = 'red', //  'error', 'failed'
}
